import clsx from 'clsx';

export interface PlaceholderProps {
    animation?: 'wave' | 'glow';
    sizing?: 'lg' | 'sm' | 'xs';
    widthClassName?: string;
}

const Placeholder = ({
    sizing,
    widthClassName = 'w-100',
    animation = 'wave',
}: PlaceholderProps): JSX.Element => {
    return (
        <p className={clsx(`placeholder-${animation} w-100 m-0`)}>
            <span
                className={clsx('placeholder bg-primary', widthClassName, {
                    'placeholder-lg': sizing === 'lg',
                    'placeholder-sm': sizing === 'sm',
                    'placeholder-xs': sizing === 'xs',
                })}
            ></span>
        </p>
    );
};

export default Placeholder;
